import React, { useEffect, useState } from "react";
import { Card } from "reactstrap";
import { Profile } from "../../../Api/apiUtils";
import { useNavigate, useParams } from "react-router-dom";

/**
 * /profile/:userId — look a person up by CMS userId and send them to their
 * real profile page, which is keyed by credentialId and studentId.
 *
 * This is the only route that takes a userId, which makes it the one link
 * worth handing out: userId is what the RM tool, Freshchat and the task
 * queue all know, and the only identifier that cannot drift away from the
 * CMS record. Everything else needs ids a caller has to look up first.
 */
function HelloWorld() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const fetchProfile = async () => {
      try {
        const userData = await Profile(userId);
        if (cancelled) return;
        if (userData?.role === "student" && userData?.studentCredential && userData?.studentId) {
          navigate(
            `${process.env.PUBLIC_URL}/pages/student-profile/${userData.studentCredential}/${userData.studentId}`,
            { replace: true },
          );
        } else if (userData?.role === "teacher" && userData?.teacherCredential && userData?.id) {
          navigate(
            `${process.env.PUBLIC_URL}/pages/teacher-profile/${userData.teacherCredential}/${userData.id}`,
            { replace: true },
          );
        } else {
          // Previously this logged to the console and left "Loading..." on
          // screen for ever, which reads as a hung page rather than a miss.
          setError(
            userData?.role
              ? `This user is a ${userData.role}, which has no profile page here.`
              : "No profile found for this user id.",
          );
        }
      } catch {
        if (!cancelled) setError("Could not load this profile. The user id may not exist.");
      }
    };
    void fetchProfile();
    return () => {
      cancelled = true;
    };
  }, [userId, navigate]);

  return (
    <Card>
      <div className="p-4">
        {error ? (
          <>
            <h5 className="fw-bold mb-1">Profile not found</h5>
            <p className="text-muted mb-1">{error}</p>
            <p className="text-muted mb-0" style={{ fontSize: 13 }}>
              User id <code>{userId}</code>
            </p>
          </>
        ) : (
          <h5 className="fw-bold mb-0">Opening profile…</h5>
        )}
      </div>
    </Card>
  );
}

export default HelloWorld;
